module.exports = __webpack_public_path__ + "img/table_header_bg_2.27a53ded.png";